import { LayoutGrid, TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import Image from '@/app/components/Image';
import Section from '@/app/components/LegacyLandingPage/components/Section';

const WhyUseApi = () => {
  const t = useTranslations();
  return (
    <Section
      className="relative -mt-7 rounded-t-xl bg-gray-200 md:rounded-t-[1.75rem]"
      padTop
    >
      <LayoutGrid className="w-full shrink-0">
        <div className="col-main lg:col-end-9 lg:mt-8 xl:col-end-10">
          <TypographyV3
            Element="h3"
            variant="h4"
            className="md:text-center lg:text-left"
          >
            {t('developer_secondary_title')}
          </TypographyV3>
        </div>
        <div className="col-main mt-8 flex justify-center lg:col-start-10 lg:col-end-15">
          <div className="max-w-72">
            <Image
              src="developer/d-score-cards-ui-fpo"
              format="png"
              alt="Screen shot of Oura mobile app showing Readiness and Sleep scores"
              width={400}
              height={300}
            />
          </div>
        </div>
        <div className="col-main mt-8 flex flex-col-reverse lg:col-start-16 lg:col-end-main">
          <TypographyV3 Element="p" variant="h6">
            {t('developer_secondary_body')}
          </TypographyV3>
        </div>
      </LayoutGrid>
    </Section>
  );
};

export default WhyUseApi;
